module.exports = __webpack_public_path__ + "img/knsu_gallery9.b2d0c66c.jpg";